<template>
  <HomeSection :title="t('menu.myPets')">
    <RouterLink
      v-for="pet in pets"
      :key="pet.id"
      :to="`/animal/${pet.id}`"
      class="pet"
      draggable="false"
    >
      <img
        v-if="pet.payload?.photos?.[0]?.path"
        :src="pet.payload.photos[0].path"
        class="pet__img"
        alt=""
      >
      <IconBase
        v-else
        :path="`animals/${getAnimalById(pet.payload?.animal_id || pet.animal_id)?.icon || 'cat'}.svg`"
        class="pet__img pet__img--icon"
      />
      <div class="pet__body">
        <div class="pet__name">
          {{ pet.payload?.name }}
        </div>
        <div class="pet__breed">
          {{ pet.payload?.breed }}
        </div>
      </div>
    </RouterLink>

    <RouterLink
      to="/pet-create"
      class="pet pet--add"
      draggable="false"
    >
      <span class="pet__plus">+</span>
      <span class="pet__add-text">{{ t('home.addPet') }}</span>
    </RouterLink>
  </HomeSection>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { IconBase } from '@/UI'
import { getAnimalById } from '@/helpers/helpers'
import { useUser } from '@/composables/useUser'
import { getMyAnimals } from '../homeApi'
import HomeSection from './HomeSection.vue'

const { t } = useI18n()
const { isAuthenticated } = useUser()

const pets = ref([])

onMounted(async () => {
  if (!isAuthenticated.value) {return}
  pets.value = await getMyAnimals()
})
</script>

<style lang="scss" scoped>
.pet {
  flex: none;
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 170px;
  padding: 8px 16px 8px 8px;
  border-radius: 22px;
  background: #fff;
  color: inherit;
  text-decoration: none;

  &__img {
    width: 56px;
    height: 56px;
    border-radius: 16px;
    object-fit: cover;

    &--icon {
      padding: 10px;
      background: #f2f8ff;
      object-fit: contain;
    }
  }

  &__name {
    font-size: 14px;
    font-family: "NunitoBold";
    color: #26384b;
  }

  &__breed {
    margin-top: 2px;
    font-size: 13px;
    font-family: "NunitoBold";
    color: #8f98ab;
  }

  &--add {
    background: #fff;
    padding-left: 8px;
  }

  &__plus {
    flex: none;
    width: 56px;
    height: 56px;
    border-radius: 16px;
    background: #9ad03b;
    color: #26384b;
    font-size: 34px;
    line-height: 56px;
    text-align: center;
  }

  &__add-text {
    max-width: 90px;
    font-size: 13px;
    font-family: "NunitoBold";
    color: #26384b;
  }
}

[theme="dark"] {
  .pet,
  .pet--add {
    background: #37363c;
  }

  .pet__name,
  .pet__add-text {
    color: #fff;
  }

  .pet__img--icon {
    background: #292929;
  }
}
</style>
